<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <div>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Materia
                      </th>
                      <th class="text-left">
                        Nota
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(notaData,
                      notaKey) in notas"
                      :key="notaKey"
                    >
                      <td>{{ notaData.Materia }}</td>
                      <td>{{ notaData.nota }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    
  },

  data: () => ({
    title:"Notas Materias",
    notas:[],  
  }),
  mounted() {
    this.$API
      .get({
        url: "examenes/notas"
      }).then((res) => {
        this.notas = res;
      });
  },
};
</script>
